import { RouterModule, Routes } from '@angular/router';
import { NgbCarouselModule, NgbDropdownModule, NgbNavModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { TranslateModule } from '@ngx-translate/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ActivityBadgeComponent } from '../activity-badge/activity-badge.component';
import { AgentBreakPageComponent } from '../agent-break-page/agent-break-page.component';
import { ContactManagerPageComponent } from '../contact-manager-page/contact-manager-page.component';
import { ConvActionsFooterDefaultComponent } from '../conv-actions-footer-default/conv-actions-footer-default.component';
import { ConvActionsFooterComponent } from '../conv-actions-footer/conv-actions-footer.component';
import { ConvActionsComponent } from '../conv-actions/conv-actions.component';
import { ConvBodyComponent } from '../conv-body/conv-body.component';
import { ConvHeaderComponent } from '../conv-header/conv-header.component';
import { ConvSidebarLeadInfoComponent } from '../conv-sidebar-lead-info/conv-sidebar-lead-info.component';
import { ConvSidebarQuestionsComponent } from '../conv-sidebar-questions/conv-sidebar-questions.component';
import { ConvSidebarTemplatesComponent } from '../conv-sidebar-templates/conv-sidebar-templates.component';
import { ConvSidebarComponent } from '../conv-sidebar/conv-sidebar.component';
import { ConvComponent } from '../conv/conv.component';
import { EmojiPickerComponent } from '../emoji-picker/emoji-picker.component';
import { EventActionMenuComponent } from '../event-action-menu/event-action-menu.component';
import { AssignmentGuard } from '../guards/assignment.guard';
import { BreakGuard } from '../guards/break.guard';
import { CurrentJobGuard } from '../guards/current-job.guard';
import { DefaultJobGuard } from '../guards/default-job.guard';
import { JobsGuard } from '../guards/jobs.guard';
import { TeamGuard } from '../guards/team.guard';
import { HomePageAnnouncementsComponent } from '../home-page-announcements/home-page-announcements.component';
import { HomePageDefaultComponent } from '../home-page-default/home-page-default.component';
import { HomePageComponent } from '../home-page/home-page.component';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { NoTeamAgentPageComponent } from '../no-team-agent-page/no-team-agent-page.component';
import { PendingAgentPageComponent } from '../pending-agent-page/pending-agent-page.component';
import { DateProxyPipe } from '../pipes/date-proxy.pipe';
import { TemplateService } from '../services/template.service';
import { SharedModule } from '../shared/shared.module';
import { SidebarConvListComponent } from '../sidebar-conv-list/sidebar-conv-list.component';
import { SidebarEmptyImageComponent } from '../sidebar-empty-image/sidebar-empty-image.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { SkillsCheckModalComponent } from '../skills-check-modal/skills-check-modal.component';
import { TransmissionRateIndicatorComponent } from '../transmission-rate-indicator/transmission-rate-indicator.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { SpeedTestOverlayComponent } from '../speed-test-overlay/speed-test-overlay.component';
import { MainComponent } from './main.component';

const routes: Routes = [
  {
    path: 'jobs',
    component: MainComponent,
    canActivate: [TeamGuard, BreakGuard, AssignmentGuard],
    children: [
      {
        path: 'default',
        pathMatch: 'full',
        canActivate: [DefaultJobGuard]
      },
      {
        path: ':jobid',
        canActivateChild: [CurrentJobGuard],
        children: [
          {
            path: 'conv/:convid',
            component: ConvComponent
          },
          {
            path: '',
            pathMatch: 'full',
            component: HomePageComponent
          }
        ]
      },
      { path: '', pathMatch: 'full', redirectTo: 'default' }
    ]
  },
  {
    path: 'pending',
    component: PendingAgentPageComponent,
    canActivate: [TeamGuard, BreakGuard]
  },
  {
    path: 'awaiting-team',
    component: NoTeamAgentPageComponent
  },
  {
    path: 'break',
    component: AgentBreakPageComponent,
    canActivate: [TeamGuard]
  },
  {
    path: 'contact-manager',
    component: ContactManagerPageComponent,
    canActivate: [TeamGuard]
  },
  { path: '', pathMatch: 'full', redirectTo: 'jobs/default' }
];

@NgModule({
  declarations: [
    MainComponent,
    PendingAgentPageComponent,
    SidebarComponent,
    HomePageComponent,
    ConvComponent,
    ConvBodyComponent,
    ConvActionsFooterComponent,
    ConvActionsFooterDefaultComponent,
    SidebarConvListComponent,
    SidebarEmptyImageComponent,
    ConvSidebarComponent,
    ConvSidebarLeadInfoComponent,
    ConvSidebarQuestionsComponent,
    ConvSidebarTemplatesComponent,
    ConvActionsComponent,
    ActivityBadgeComponent,
    ConvHeaderComponent,
    EmojiPickerComponent,
    EventActionMenuComponent,
    HomePageDefaultComponent,
    HomePageAnnouncementsComponent,
    MediaPreviewComponent,
    UserMenuComponent,
    SkillsCheckModalComponent,
    NoTeamAgentPageComponent,
    TransmissionRateIndicatorComponent,
    AgentBreakPageComponent,
    ContactManagerPageComponent,
    SpeedTestOverlayComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    InfiniteScrollModule,
    NgbCarouselModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbPopoverModule,
    PickerModule,
    SharedModule,
    TranslateModule.forChild({ extend: true }),
    SweetAlert2Module
  ],
  providers: [CurrentJobGuard, DefaultJobGuard, JobsGuard, TemplateService, DateProxyPipe, TeamGuard, AssignmentGuard]
})
export class MainModule {}
